import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-section-loader',
  templateUrl: './section-loader.component.html',
  styleUrls: ['./section-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SectionLoaderComponent {
  @Input() public display: boolean;
  @Input() public error: boolean;
}
